module.exports = __webpack_public_path__ + "img/grade1.32b60ddc.png";